export const amount = (value) => {
  if (value === undefined) return ''
  let str = typeof value === 'string' ? value : String(value)
  return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
}
